//import liraries
import React, { Component, useState } from "react";
import {
  View,
  Text,
  StyleSheet,
  TextInput,
  Dimensions,
  TouchableOpacity,
  Image,
  Linking
} from "react-native";
import AsyncStorageFunc from '../../utilities/asyncStorage';
import * as RootNavigation from "../../utilities/RootNavigation";
import { useLocation } from "react-router-dom";
const isSmallDevice = Dimensions.get("window").width < 767;
const isTabView =
  Dimensions.get("window").width > 767 && Dimensions.get("window").width < 1024;


// define your styles
const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#2c3e50',
    },
    quickLinksTextStyle: {
        fontFamily: "Inter",
        fontSize: isSmallDevice ? 8 : 13,
        fontWeight: "normal",
        fontStyle: "normal",
        lineHeight: 14,
        letterSpacing: 0.39,
        textAlign: "left",
        color: "#30424e",
        paddingBottom: 13,
        paddingTop: 5,
      },
});

//make this component available to the app
export default styles;
